module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('svg', {
    attrs: {
      "id": "asbestos",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 147.8 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M15 0H0v50.6h15V14.8h90.2v90.4H14.8v-39H0V120h120V0zM132.2 104.4h15.6V120h-15.6z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "close",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M69.8 60L118 11.8c2.7-2.7 2.7-7.1 0-9.8-2.7-2.7-7.1-2.7-9.8 0L60 50.2 11.8 2C9.1-.7 4.7-.7 2 2-.7 4.7-.7 9.1 2 11.8L50.2 60 2 108.2c-2.7 2.7-2.7 7.1 0 9.8 1.4 1.4 3.1 2 4.9 2s3.5-.7 4.9-2L60 69.8l48.2 48.2c1.4 1.4 3.1 2 4.9 2 1.8 0 3.5-.7 4.9-2 2.7-2.7 2.7-7.1 0-9.8L69.8 60z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "noise",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M113.2 43.3c0-15.5-4.7-30.5-13.4-43.3H86.9C97.3 12 103 27.4 103 43.3c0 36.7-29.8 66.4-66.4 66.4-10.3 0-20.5-2.4-29.7-7v5.2c0 2.2.3 4.3.8 6.4 9.2 3.8 19 5.7 28.9 5.7 42.2 0 76.6-34.4 76.6-76.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M91.7 43.3c0-16.9-7.7-32.8-21-43.3H48.4c23.9 6.6 38 31.3 31.4 55.2-6.6 23.9-31.3 38-55.2 31.4-6.6-1.8-12.7-5.1-17.9-9.7v12.8c25.6 16.4 59.8 9 76.2-16.7 5.8-8.8 8.8-19.2 8.8-29.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M36.5 76.3c18.3 0 33.1-14.8 33.1-33.1s-14.8-33-33.1-33c-12.6 0-24.2 7.2-29.7 18.6v29c5.5 11.3 17.1 18.5 29.7 18.5zm0-56.9c13.2 0 23.9 10.7 23.9 23.9S49.7 67.2 36.5 67.2 12.6 56.5 12.6 43.3s10.7-23.9 23.9-23.9z"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "36.5",
      "cy": "43.3",
      "r": "8.9"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "open",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M99.1 55.7c-1.8 0-3.5-.7-4.9-2L60 19.5 25.8 53.7c-2.7 2.7-7 2.7-9.7 0-2.7-2.7-2.7-7.1 0-9.7L60 0l44 44c2.7 2.7 2.7 7.1 0 9.7-1.4 1.4-3.1 2-4.9 2zM60 120L16 76c-2.7-2.7-2.7-7.1 0-9.7 2.7-2.7 7-2.7 9.7 0L60 100.5l34.2-34.2c2.7-2.7 7-2.7 9.7 0 2.7 2.7 2.7 7.1 0 9.7L60 120z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "passport",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M61.9.2c-.5-.2-1.1-.2-1.7-.2-.6 0-1.2 0-1.7.2C26.1 1.1.1 27.6.1 60.1.1 93.1 27 120 60 120s59.9-26.9 59.9-59.9c0-32.4-25.8-58.9-58-59.9zm48.7 55.3H93.3c-1.1-15.2-7.9-30.2-20.4-44.6 20.4 5.4 35.8 23.1 37.7 44.6zm-55.4 0H36.1c1.2-13.4 7.5-26.8 19.1-39.8v39.8zm0 9.1v39.5C48 96.2 37.7 82.2 36.1 64.6h19.1zm9.9 0h19.1C82.6 82.1 72.3 96.1 65.1 104V64.6zm0-9.1V15.7c11.6 13 18 26.4 19.1 39.8H65.1zM47.5 10.8C35 25.2 28.1 40.2 27 55.5H9.4C11.3 33.8 26.9 16 47.5 10.8zM9.4 64.6H27c1.5 20.1 12.5 35.8 20.8 44.9-20.7-5.2-36.5-23.1-38.4-44.9zm63.2 44.8c8.2-9.1 19.2-24.8 20.7-44.8h17.3c-1.9 21.7-17.5 39.5-38 44.8z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "quantum",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60 0C26.9 0 0 26.9 0 60s26.9 60 60 60 60-26.9 60-60S93.1 0 60 0zm0 101.9c-23.2 0-41.9-18.8-41.9-41.9S36.8 18.1 60 18.1s41.9 18.8 41.9 41.9-18.7 41.9-41.9 41.9z"
    }
  }), _c('path', {
    attrs: {
      "d": "M114.3 117.8c-3.7 3.2-9.4 2.9-12.7-.9l-9.8-11.3c-3.2-3.7-2.9-9.4.9-12.7 3.7-3.2 9.4-2.9 12.7.9l9.8 11.3c3.3 3.7 2.9 9.5-.9 12.7z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3aa2d54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PassportIcons.vue
// module id = 1803
// module chunks = 0